<template>
  <div class="material-view-form-container">
    <el-tabs v-model="material_data.tab">
      <el-tab-pane v-if="material_data?.videos && (!material_type || material_type === 'video')" name="video">
        <div slot="label">视频<span>({{ material_data?.videos?.length }})</span></div>
        <RecycleScroller
          v-show="material_data.videos.length"
          v-slot="{ item, index }"
          class="material-content"
          :items="material_data.videos"
          key-field="id"
          :grid-items="2"
          :item-size="172"
          :item-secondary-size="videos_container_width / 2"
          list-class="recycle-scroller-videos-container"
        >
          <div
            class="material-item material-item-video"
            :class="{ 'video-vertical': isHorizontalCover(item), 'video-horizontal': showVerticalCover }"
          >
            <div class="item-border">
              <div class="item-content">
                <div class="video-item">
                  <video :src="item.url[0].url" controls />
                </div>
                <div class="video-item">
                  <el-image fit="contain" :src="item.url[0].thumb_url" />
                  <div class="img-func">
                    <el-button
                      class="el-button-scale"
                      icon="el-icon-zoom-in"
                      circle
                      @click.stop="openViewer(material_data.videos, index)"
                    />
                    <el-button
                      class="el-button-replace"
                      size="mini"
                      type="primary"
                      @click="replaceCover(item)"
                    >
                      更换封面
                    </el-button>
                  </div>
                </div>
                <div v-if="showVerticalCover" class="video-item">
                  <el-image v-show="item.url[0].vertical_cover" fit="contain" :src="item.url[0].vertical_cover" />
                  <div v-show="!item.url[0].vertical_cover" class="empty-wrapper w-full h-full flex-col items-center justify-center">
                    <i class="el-icon-picture-outline empty-icon" />
                    <div>竖版封面</div>
                    <div>(选填)</div>
                  </div>
                  <div class="img-func">
                    <div v-show="item.url[0].vertical_cover" class="action-wrapper absolute left-0 top-0 bottom-0 right-0 w-full flex justify-center items-center">
                      <el-button
                        class="el-button-scale zoom-button"
                        icon="el-icon-zoom-in"
                        circle
                        @click.stop="openViewer(material_data.videos, index, 'vertical_cover')"
                      />
                      <el-button
                        v-show="item.url[0].vertical_cover"
                        class="zoom-button"
                        style="margin-left: 5px;"
                        icon="el-icon-delete"
                        circle
                        @click.stop="deleteCover(item, 'vertical_cover')"
                      />
                    </div>
                    <el-button
                      class="el-button-replace"
                      size="mini"
                      type="primary"
                      @click="replaceCover(item, 'vertical_cover')"
                    >
                      750 * 1000
                    </el-button>
                  </div>
                </div>
                <div v-if="isHorizontalCover(item)" class="video-item">
                  <el-image v-show="item.url[0].horizontal_cover" fit="contain" :src="item.url[0].horizontal_cover" />
                  <div v-show="!item.url[0].horizontal_cover" class="empty-wrapper w-full h-full flex-col items-center justify-center">
                    <i class="el-icon-picture-outline empty-icon" />
                    <div>横版封面</div>
                    <div>(选填)</div>
                  </div>
                  <div class="img-func">
                    <div v-show="item.url[0].horizontal_cover" class="action-wrapper absolute left-0 top-0 bottom-0 right-0 w-full flex justify-center items-center">
                      <el-button
                        class="el-button-scale zoom-button"
                        icon="el-icon-zoom-in"
                        circle
                        @click.stop="openViewer(material_data.videos, index, 'horizontal_cover')"
                      />
                      <el-button
                        class="zoom-button"
                        style="margin-left: 5px;"
                        icon="el-icon-delete"
                        circle
                        @click.stop="deleteCover(item, 'horizontal_cover')"
                      />
                    </div>
                    <el-button
                      class="el-button-replace"
                      size="mini"
                      type="primary"
                      @click="replaceCover(item, 'horizontal_cover')"
                    >
                      1140 * 640
                    </el-button>
                  </div>
                </div>
              </div>
              <i
                class="el-icon-error item-close"
                @click="deleteMaterial(material_data.videos, index)"
              />
              <el-tooltip
                effect="dark"
                :content="item.name"
                placement="bottom-start"
              >
                <div class="title">{{ item.name }}</div>
              </el-tooltip>
            </div>
          </div>
        </RecycleScroller>
        <el-empty v-show="material_data?.videos?.length === 0" v-bind="empty_config.props" />
      </el-tab-pane>
      <el-tab-pane v-if="material_data?.images && (!material_type || material_type === 'image' || material_type === 'element_story')" name="image">
        <div slot="label">图片<span>({{ material_data?.images?.length }})</span></div>
        <RecycleScroller
          v-show="material_data.images.length"
          v-slot="{ item, index }"
          class="material-content"
          :items="material_data.images"
          key-field="id"
          :grid-items="4"
          :item-size="172"
          :item-secondary-size="images_container_width / 4"
          list-class="recycle-scroller-images-container"
        >
          <div
            class="material-item"
          >
            <div class="item-border">
              <div class="item-content" style="position: relative">
                <el-image v-for="pick_image in item.url" :key="pick_image?.thumb_url" :style="{width: `calc(100% / ${item.url.length})`}" fit="contain" :src="pick_image?.thumb_url" />
                <div class="img-func">
                  <el-button
                    class="el-button-scale"
                    icon="el-icon-zoom-in"
                    circle
                    @click.stop="openViewer(material_data.images, index)"
                  />
                </div>
              </div>
              <i
                class="el-icon-error item-close"
                @click="deleteMaterial(material_data.images, index)"
              />
              <el-tooltip
                effect="dark"
                :content="item.name"
                placement="bottom-start"
              >
                <div class="title">{{ item.name }}</div>
              </el-tooltip>
            </div>
          </div>
        </RecycleScroller>
        <el-empty v-show="material_data?.images?.length === 0" v-bind="empty_config.props" />
      </el-tab-pane>
    </el-tabs>
    <div class="clear cursor-pointer" @click="clearMaterial">清空</div>
    <el-image-viewer
      v-if="image_viewer_config.is_show"
      v-bind="image_viewer_config.props"
      :on-close="closeViewer"
    />
    <material-box
      v-if="material_config.is_show"
      :advertiser="channel_interface"
      :is-open="material_config.is_show"
      v-bind="material_config.props"
      @confirm="materialConfirm"
      @cancel="materialCancel"
    />
  </div>
</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';
import resize_observer_mixin from '@/mixins/resizeObserver';

export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
    'material-box': () => import('@/components/material-box'),
  },
  mixins: [data_sharing_mixin, resize_observer_mixin],
  props: {
    /** 表单配置 */
    formFields: {
      type: Object,
      default: () => {},
    },
    /** 是否显示竖版视频横版封面 */
    showHorizontalCover: {
      type: Boolean,
      default: () => false,
    },
    /** 是否显示竖版封面 */
    showVerticalCover: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      /** 空数据配置 */
      empty_config: {
        props: {
          description: '暂无配置',
        },
      },
      /** 素材库配置 */
      material_config: {
        is_show: false,
        material_item: null,
        // 封面类型 - thumb_url：默认封面、horizontal_cover：横板封面、vertical_cover：竖版封面
        cover_type: 'thumb_url',
        props: {
          type: 'image',
          tempMaterial: null,
        },
      },
      /** 图片预览配置 */
      image_viewer_config: {
        is_show: false,
        props: {
          initialIndex: null,
          urlList: [],
          zIndex: 9999,
        },
      },
      /** 视频容器宽度 */
      videos_container_width: 0,
      /** 图片容器宽度 */
      images_container_width: 0,
    };
  },
  computed: {
    /** 素材数据 */
    material_data() {
      const { value } = this.formFields?.config?.material_form?.config?.material;
      return value;
    },
    /** 素材库类型 */
    material_type() {
      const { strategy } = this.local_sharing_data.getFormContext();
      const { type } = strategy.getMaterialProps(this.formFields);
      return type;
    },
    /** 渠道接口 */
    channel_interface() {
      const { channel_interface } = this.getInitConfig();
      return channel_interface;
    },
  },
  mounted() {
    // 开始监听所有容器尺寸变化
    this.observeResize([
      {
        target: '.recycle-scroller-videos-container',
        callback: (width) => {
          this.videos_container_width = width;
        },
      },
      {
        target: '.recycle-scroller-images-container',
        callback: (width) => {
          this.images_container_width = width;
        },
      },
    ]);
  },
  methods: {
    /** 获取初始化配置 */
    getInitConfig() {
      try {
        const { getFormContext } = this.local_sharing_data;
        const form_context = getFormContext();
        const { init_ops } = form_context.config;
        return init_ops || {};
      } catch {
        return {};
      }
    },
    /**
     * 打开预览幻灯片
     * @param {Object[]} list 素材列表 - 图片、视频
     * @param {number} index 素材索引
     * @param {string} cover_type 封面类型 - thumb_url：默认封面、horizontal_cover：横板封面、vertical_cover：竖版封面
     */
    openViewer(list, index, cover_type = 'thumb_url') {
      Object.assign(this.image_viewer_config.props, {
        initialIndex: index,
        urlList: list.map((item) => (item.url.map((u) => u[cover_type]))).flat(Infinity),
      });
      this.image_viewer_config.is_show = true;
    },
    /** 关闭预览幻灯片 */
    closeViewer() {
      this.image_viewer_config.is_show = false;
    },
    /**
     * 删除素材
     * @param {Object[]} list 素材列表 - 图片、视频
     * @param {number} index 素材索引
     */
    deleteMaterial(list, index) {
      list.splice(index, 1);
    },
    /**
     * 更换封面
     * @param {Object} material_item 当前素材
     * @param {string} cover_type 封面类型 - thumb_url：默认封面、horizontal_cover：横板封面、vertical_cover：竖版封面
     * @returns {void}
     */
    replaceCover(material_item, cover_type = 'thumb_url') {
      const { width, height, size } = this.getMaterialStylePosterInfo(material_item, cover_type);
      const tempMaterial = Object.assign(JSON.parse(JSON.stringify(material_item)), { width, height, size });
      Object.assign(this.material_config.props, { tempMaterial });
      Object.assign(this.material_config, { material_item, cover_type });
      this.material_config.is_show = true;
    },
    /**
     * 删除封面 - 选填的竖版、横板封面
     * @param {Object} material_item 当前素材
     * @param {string} cover_type 封面类型 - thumb_url：默认封面、horizontal_cover：横板封面、vertical_cover：竖版封面
     * @returns {void}
     */
    deleteCover(material_item, cover_type = 'horizontal_cover') {
      // 此处写法目的是触发响应式更新
      const temp_url = JSON.parse(JSON.stringify(material_item.url));
      temp_url[0][cover_type] = '';
      material_item.url = temp_url;
    },
    /**
     * 素材库确认 - 封面逻辑
     * @param {Object} data 素材库选中的素材
     */
    materialConfirm(data) {
      if (data.length === 0) {
        return;
      }
      const { cover_type } = this.material_config;
      this.material_config.material_item.url[0][cover_type] = data[0].url[0].url;
      this.materialCancel();
    },
    /** 素材库取消 */
    materialCancel() {
      Object.assign(this.material_config.props, { tempMaterial: null });
      Object.assign(this.material_config, { material_item: null, cover_type: 'thumb_url' });
      this.material_config.is_show = false;
    },
    /**
     * 清空当前标签页素材
     * @returns {void}
     */
    clearMaterial() {
      const h = this.$createElement;
      this.$msgbox({
        title: '提示',
        message: h('p', null, [
          h('span', null, '是否'),
          h('span', { style: { color: '#F56C6C', margin: '0 2px' }}, '清空'),
          h('span', null, '当前已添加的所有素材'),
        ]),
        showCancelButton: true,
      }).then(() => {
        const tab = this.material_data.tab;
        this.material_data[`${tab}s`].splice(0);
      });
    },
    /**
     * 是否为横板封面
     * @param {Object} material_item 当前素材
     * @returns {Boolean}
     */
    isHorizontalCover(material_item = {}) {
      /**
       * 宽高为以下尺寸时，为竖版视频，即支持横板封面
       * - 720 * 1280
       */
      const valid_sizes = [[720, 1280]];
      const { width, height } = material_item;
      const is_vertical_video = valid_sizes.some(([width_size, height_size]) => width === width_size && height === height_size);
      return this.showHorizontalCover && is_vertical_video;
    },
    /**
     * 获取素材封面信息
     * @param {Object} material_item 当前素材
     * @param {string} cover_type 封面类型 - thumb_url：默认封面、horizontal_cover：横板封面、vertical_cover：竖版封面
     * @returns {Object}
     */
    getMaterialStylePosterInfo(material_item, cover_type = 'thumb_url') {
      const { width, height, size } = material_item;
      // 默认封面 - 使用素材中的规格
      if (cover_type === 'thumb_url') {
        return { width, height, size };
      }
      const { material } = this.formFields.config.material_form.config;
      const { video = {}} = material;

      const target_key = Object.keys(video).find(keys => {
        const video_width = keys.split('#')[0];
        const video_height = keys.split('#')[1];
        return Number(width) === Number(video_width) && Number(height) === Number(video_height);
      }) || '';

      const cover_config = video[target_key] || {};

      return cover_config[cover_type] || {};
    },
  },
};
</script>

<style lang="scss" scoped>
.material-view-form-container {
  position: relative;
  height: 400px;
  .clear {
    position: absolute;
    right: 20px;
    top: 13px;
    color: #409eff;
    font-size: 12px;
    &:hover {
      color: #66b1ff;
    }
  }
  /deep/ .el-tabs--border-card > .el-tabs__content {
    padding: 0;
  }
  .material-content {
    height: 344px !important;
    padding: 10px;
    padding-top: 0;
    .material-item {
      width: 100%;
      height: 100%;
      padding: 10px;
      .item-border {
        position: relative;
        width: 100%;
        height: 100%;
        padding: 10px;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        display: flex;
        flex-direction: column;
        padding-bottom: 0;
        .item-content {
          flex: 1;
          min-height: 0;
        }
        video,
        .el-image {
          width: 100%;
          height: 100%;
          background-color: #333;
          object-fit: contain;
        }
        .img-func {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          overflow: hidden;
          transition: all 0.3s;
          .el-button.el-button-scale {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            width: 36px;
            height: 36px;
            margin: auto;
            background-color: #3333336e;
            color: #fff;
            &:hover {
              transform: scale(1.2);
            }
          }
          .action-wrapper {
            margin: auto;
            .el-button.el-button-scale.zoom-button {
              position: static;
              margin: 0;
            }
          }
          .el-button-replace {
            position: absolute;
            right: -1px;
            bottom: -29px;
          }
          &:hover {
            .el-button-replace {
              bottom: -1px;
            }
          }
        }
        .item-close {
          position: absolute;
          right: -5px;
          top: -5px;
          font-size: 15px;
          cursor: pointer;
        }
      }
      &.material-item-video {
        &.video-vertical,
        &.video-horizontal {
          width: 100%;
          .item-content {
            display: flex;
            div.video-item {
              padding: 0 5px;
              flex: 1;
            }
          }
        }
        .video-item {
          position: relative;
          float: left;
          width: 50%;
          height: 100%;
          &:nth-child(1) {
            padding-right: 5px;
          }
          &:nth-child(2) {
            padding-left: 5px;
          }
          .empty-wrapper {
            background-color: #f5f7fa;
            .empty-icon {
              font-size: 32px;
            }
          }
        }
      }
    }
  }
  .title {
    line-height: 28px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  /deep/ .el-tabs__item {
    width: 80px;
    text-align: center;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
</style>
